import { defineMessages } from 'react-intl';

export default defineMessages({
  currency: {
    id: 'currency',
    description: 'USD',
    defaultMessage: 'USD',
  },
  totalPriceLabel: {
    id: 'template.totalPrice',
    description: 'total price',
    defaultMessage: 'total price',
  },
  priceBandLabel: {
    id: 'model.priceBand',
    description: 'price band',
    defaultMessage: 'price band',
  },
  suggestedLabel: {
    id: 'template.suggested',
    description: 'suggested',
    defaultMessage: 'suggested',
  },
  functionalGroupHeader: {
    id: 'functionalGroup',
    description: 'functional group',
    defaultMessage: 'Functional Group',
  },
  designPackageHeader: {
    id: 'template.designPackage',
    description: 'design package',
    defaultMessage: 'design package',
  },
  templateOverviewHeader: {
    id: 'templateOverview',
    description: 'template overview',
    defaultMessage: 'template overview',
  },
  unit: {
    id: 'unit',
    description: 'unit label',
    defaultMessage: 'unit',
  },
  units: {
    id: 'units',
    description: 'unit label',
    defaultMessage: 'units',
  },
  detailString: {
    id: 'detail',
    description: 'detail',
    defaultMessage: 'Detail',
  },
  closeString: {
    id: 'close',
    description: 'close',
    defaultMessage: 'Close',
  },
});
